module.exports = __webpack_public_path__ + "static/media/slide2.54b66d1a.svg";